import {html, type TemplateResult} from 'lit';
import type {CityData, WeatherData} from '../weather';
import {getTemperature} from './temperature';

/**
 * City list
 * @param {Object} data
 * @param {number} data.day
 * @param {Array} data.cities
 * @param {string} data.region
 * @return {TemplateResult}
 */
const cities = (data: WeatherData): TemplateResult => html`
  <ul>
    ${data.cities.map((c: CityData) => html`
      <li>
        <span class="city-name"><a href="${c.url}">${c.city}</a></span>
        <span class="w-icon">
          <span title="${c.forecasts[data.day].forecastDailyAverage.altText}"
                class="icon-weather wi-${c.forecasts[data.day].forecastDailyAverage.icon}"></span>
        </span>
        <span class="temp">
          ${getTemperature(c.forecasts[data.day])}
        </span>
      </li>
    `)}
  </ul>
`;

/**
 * Map
 * @param {Object} data
 * @param {string} data.region
 * @param {Array} data.cities
 * @param {number} data.day
 * @return {TemplateResult}
 */
const citiesDesktop = (data: WeatherData): TemplateResult => html`
  <div class="pic-maps ${data.region}"></div>
  ${data.cities.map(c => html`
    <div class="city city-${c.encodedName}">
      <a href="${c.url}">
        <span class="label">${c.city}</span>
        <span class="temp">
          ${getTemperature(c.forecasts[data.day])}
          <span title="${c.forecasts[data.day].forecastDailyAverage.altText}"
                class="icon-weather wi-${c.forecasts[data.day].forecastDailyAverage.icon}"></span>
        </span>
      </a>
    </div>
  `)}
`;

export {cities, citiesDesktop};
